import PropTypes from "prop-types"
import { Route } from "react-router-dom"

import { Routes } from "helpers/sentry"

import Homepage from "./homepage"

import Article from "./"

const ArticleLanding = ({ articleData }) => {
  return (
    <div className="contained tablet:pb-0 px-16 pb-32">
      <Routes>
        <Route
          element={<Article articleData={articleData} />}
          path=":article_path"
        />
        <Route element={<Homepage articleData={articleData} />} index />
      </Routes>
    </div>
  )
}

ArticleLanding.propTypes = {
  articleData: PropTypes.object,
}

export default ArticleLanding
